import { Component, OnInit } from '@angular/core';
import {ProvinceService} from '../../../services/province/province.service';
import {DataTableService} from '../../../modules/UIKit/components/dataTable/dataTable.service';
import {TranslateService} from '@ngx-translate/core';
import {DataTableField} from '../../../modules/UIKit/components/dataTable/dataTableField.interface';
import {Province} from '../../../models/province.model';

@Component({
  selector: 'app-province',
  templateUrl: './province.component.html',
  styleUrls: ['./province.component.css'],
  providers: []
})
export class ProvinceComponent implements OnInit {

  provinces: Array<Province>;
  selectedProvince: Province = null;
  provinceListTitles: DataTableField[];
  newDataAvailable = false;
  modalTitle = '';
  labels = {}
  show = {
    modal:false
  }

  constructor(
    public srvProvince: ProvinceService,
    private srvDataTable: DataTableService,
    private translate: TranslateService
  ) {
    this.translate.get(['provinceList']).subscribe((res) => {
      console.log(res);
      this.provinceListTitles = [
        { id: 'id', label: '#' },
        { id: 'code', label: res.provinceList.code },
        { id: 'name', label: res.provinceList.name },
        { id: 'country', label: res.provinceList.country },
        { id: 'state', label: res.provinceList.state }
      ];
    });
  }

  ngOnInit() {    

    this.refresh();

    this.translate.get([
      'provinceList.add_title',
      'provinceList.edit_title'
    ]).subscribe((res) => {
      this.labels['add_title'] = res['provinceList.add_title'];
      this.labels['edit_title'] = res['provinceList.edit_title'];
    });

    this.srvProvince.getAll().subscribe();
  }

  showAddOrEditDialog(data): void {
    this.modalTitle = data == null ? this.labels['add_title'] : this.labels['edit_title'];
    this.selectedProvince = data == null ? new Province() : data;  
    this.show.modal = true;
  }

  delete (record): void {
    this.srvProvince.delete(record).subscribe(() => {
      this.refresh();
      this.newDataAvailable = true;
    });
  }

  provinceAdded($event): void {
    this.srvProvince.post($event).subscribe(() => {
      this.refresh();
      this.newDataAvailable = true;
      this.show.modal = false;
    });
  }

  provinceUpdated($event): void {
    this.srvProvince.put($event).subscribe(() => {       
        this.refresh();
        this.newDataAvailable = true;
        this.show.modal = false;
      }
    )
  }
  refresh(){
    this.provinces = [];
    this.srvProvince.getAll().subscribe(res=>{      
      if(res){
        this.provinces = res;
      }
    });


  }
}



// WEBPACK FOOTER //
// ./src/app/views/administration/province/province.component.ts